import {BaseConnection} from './BaseConnection';

export class FTPConnection extends BaseConnection {
folder: string;
}

